import { RedactionOptions } from './redact';

type LogFunction = (message: string, attributes?: Object) => void;

export enum LogLevel {
  silly = 0,
  trace = 1,
  debug = 2,
  info = 3,
  warn = 4,
  error = 5,
  fatal = 6,
  log = 7,
}

export type LogType = keyof typeof LogLevel;

export interface LoggerInterface {
  silly: LogFunction;
  trace: LogFunction;
  debug: LogFunction;
  info: LogFunction;
  warn: LogFunction;
  error: LogFunction;
  fatal: LogFunction;
  log: LogFunction;
  child(attributes: Object, LoggerOptions?: LoggerOptions): LoggerInterface;
}

export interface LoggerOptions {
  redaction?: RedactionOptions;
  desiredLogLevel?: LogLevel;
}

export interface LibraryLoggingAttributes {
  lib: {
    name: string;
    version: string;
  };
}

export interface MfeLoggingAttributes {
  mfe: {
    name: string;
    version: string;
    gatsbyPhase: string;
    environment: string;
  };
}
